// extracted by mini-css-extract-plugin
export default {"menuAside":"MenuAside_menuAside__K-JZQ","menuAsideIsHovered":"MenuAside_menuAsideIsHovered__Z2W5+"};